import { useCallback, useEffect } from 'react';
import { useEffectOnce } from 'react-use';
import { ShopCategoriesGrid } from '~/components/ui/Shop';
import {
	ShopCategory,
	useShopCategoryControls,
} from '~/components/ui/ShopCategory';
import {
	setActiveCategory,
	setActiveStage,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { categories, getCategoryByType } from './CategoryTab.model';

const CategoryTab: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const activeCategory = useLayoutSelector(
		(state) => state.carPaint.activeCategory,
	);
	const interfaceHidden = useLayoutSelector(
		(state) => state.carPaint.interfaceHidden,
	);

	const handleSelect = useCallback(
		(index: number) => {
			if (interfaceHidden) return;
			dispatch(setActiveStage(index !== 2 ? 'paint' : 'list'));
			dispatch(setActiveCategory(categories[index].type));
		},
		[interfaceHidden],
	);

	const { setMaxCategoryIndex, activeCategoryIndex, setActiveCategoryIndex } =
		useShopCategoryControls(
			activeCategory
				? categories.map((item) => item.type).indexOf(activeCategory)
				: null,
			handleSelect,
			interfaceHidden,
		);

	useEffect(() => {
		if (activeCategoryIndex === null) {
			dispatch(setActiveCategory(null));
			return;
		}

		dispatch(setActiveCategory(categories[activeCategoryIndex].type));
	}, [activeCategoryIndex]);

	useEffectOnce(() => {
		setMaxCategoryIndex(categories.length);
	});

	return (
		<ShopCategoriesGrid style={{ marginTop: 30 }}>
			{categories.map((item, index) => (
				<ShopCategory
					name={item.name}
					icon={item.image}
					key={index}
					onClick={() => !interfaceHidden && handleSelect(index)}
					isActive={getCategoryByType(activeCategory)?.id === index}
					isNew={false}
					onMouseEnter={() => !interfaceHidden && setActiveCategoryIndex(index)}
					onMouseLeave={() => !interfaceHidden && setActiveCategoryIndex(null)}
				/>
			))}
		</ShopCategoriesGrid>
	);
};

export { CategoryTab };
